import { FirebaseAuthErrorCode, ReauthErrorKind } from '@griply/types';

export const WRONG_PASSWORD_CODES: string[] = [
  FirebaseAuthErrorCode.WrongPassword,
  FirebaseAuthErrorCode.InvalidCredential,
  FirebaseAuthErrorCode.InvalidLoginCredentials,
];

// Firebase reports a bad password under three different codes depending on SDK
// and whether email-enumeration protection is on — they are one thing to the user.
export const mapReauthError = (code: string): ReauthErrorKind => {
  if (WRONG_PASSWORD_CODES.includes(code)) {
    return ReauthErrorKind.WrongPassword;
  }
  if (code === FirebaseAuthErrorCode.UserMismatch) {
    return ReauthErrorKind.UserMismatch;
  }
  return ReauthErrorKind.Unknown;
};
